import React, { useCallback, useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import * as DateFns from "date-fns";
import moment from "moment-timezone";

import FiltersTabPerformance from "./Filters";
import CondensedView from "./CondensedView";
import ExpandedView from "./ExpandedView";
import MetricByPeriodView from "./MetricByPeriodView";
import { isCC } from "../../../helpers/helpers";
import { isJustFinished } from "../../../helpers/helpersts";
import Metrics from "./Metrics";
import Loader from "../../Shared/Loader";
import { ReactComponent as CondensedLogo } from "./0001.svg";
import { ReactComponent as ExpandedLogo } from "./0003.svg";
import { useInterval, useRouter } from "../../../helpers/customHooks";
import {
  FUTURE_PRACTICE,
  LEAGUES,
  LIVE_PRACTICE,
  LOAD_EVENTS_TIME_LIVE_PAGE,
  PAST_GAME,
  PAST_PRACTICE,
  PLAYERS_DATA,
  PRACTICE,
  SCOPE,
} from "../../../config/constants";

import "react-accessible-accordion/dist/fancy-example.css";
import {
  useDataEventsDispatch,
  useDataEventsState,
  useLoadingState,
  usePlayersState,
  useUserState,
} from "../../../store/hooks";
import { PerformanceRoutes, TabPerformanceProps } from "./types";
import { useRef } from "react";
import {
  useCustomTableDispatch,
  useCustomTableState,
} from "store/hooks/customTable";
import {
  usePlayerNoteDispatch,
  usePlayerNoteState,
} from "store/hooks/playerNotes";
import {
  useCustomEventsDispatch,
  useCustomEventsState,
} from "store/hooks/customEvents";
import { AlertPageType, SpeedAlertsType } from "components/Alerting/types";
import { Drawer, Alert } from "antd";

const TabPerformance = ({
  hidden,
  hasUpdate,
  shouldDisplayProgressBar,
  targetedReprocess,
  updateTargetedPlayers,
  targetedPlayers,
  openDrawer,
  setOpenDrawer,
  updateSpeeds,
  updateSelectedPlayers,
  selectedPlayers,
  setShowUpdateSpeeds,
  showUpdateSpeeds,
  setSelectedPlayers,
  setUpdateSpeeds
}: TabPerformanceProps) => {
  const user = useUserState();
  const { dataEvent: data, meta: dataMeta } = useDataEventsState();
  const { eventType, history, params, scope, viewPracticeGamePageScope } =
    useRouter<PerformanceRoutes>();

  const { getLiveData, getDataLivePractice, getDataPastEventData } =
    useDataEventsDispatch();
  const { loadCustomAlerts, saveCustomAlerts, loadSpeedAlerts } =
    useCustomEventsDispatch();
  const { customAlerts, hitedAlerts, speedAlerts } = useCustomEventsState();
  const { customTable, customTableLive } = useCustomTableState();
  const { loadCustomTable } = useCustomTableDispatch();
  const { playersNoteTypes } = usePlayerNoteState();
  const { loadPlayersNoteType } = usePlayerNoteDispatch();
  const hasScope = scope === SCOPE.VIEW.PRACTICE.PERFORMANCE.EXPANDED.PAGE;
  const gameId = dataMeta.gameId;
  const isLoading = useLoadingState(
    hasScope ? scope : viewPracticeGamePageScope
  );
  const { excludedPlayers } = usePlayersState();
  const initialState = {
    headers: [],
    players: [],
  };

  const getInitialAlerting = () => {
    return initialState;
  };
  const [currentAlert, setCurrentAlert] = useState<AlertPageType>(
    customAlerts.customAlerts || getInitialAlerting()
  );
  const [currentHitedAlert, setCurrentHitedAlert] = useState([]);
  const { id, subTab, teamId } = params;

  const dataScope = teamId ? "data:" + teamId : "data";
  const [shownHighlights, setShownHighlights] = useState(true);
  const listOfPlayersExcluded =
    excludedPlayers && excludedPlayers[gameId]
      ? excludedPlayers[gameId].join(",")
      : null;
  const callExcluded = useRef<null | NodeJS.Timeout>(null);
  const rendersCounter = useRef(0);
  const isMobile = window.matchMedia(
    "only screen and (max-width: 900px)"
  ).matches;
  const [storedAlerts, setStoredAlerts] = useState([]);
  const [liveMonitor, setLiveMonitor] = useState(false);

  var excludePlayersAvg = () => {
    getDataPastEventData(
      teamId,
      false,
      undefined,
      undefined,
      listOfPlayersExcluded
    );
  };

  const getData = useCallback(
    (withLoader?: boolean) => {
      // when apply a filter show the loader
      if (dataMeta.type === LIVE_PRACTICE) {
        getDataLivePractice(teamId, listOfPlayersExcluded, isMobile);
      } else if (dataMeta.type === PAST_PRACTICE) {
        // past Practice or Past Game
        if (listOfPlayersExcluded !== "" && listOfPlayersExcluded !== null) {
          getDataPastEventData(
            teamId,
            !!withLoader,
            undefined,
            undefined,
            listOfPlayersExcluded
          );
        } else {
          getDataPastEventData(
            teamId,
            !!withLoader,
            undefined,
            undefined,
            undefined,
            isMobile
          );
        }
      } else if (dataMeta.type === PAST_GAME) {
        // past Practice or Past Game
        const homeTeam = data.meta.homeTeam.data;
        const awayTeam = data.meta.visitorTeam.data;
        if (homeTeam && homeTeam.teamId && homeTeam.teamId !== "00") {
          getDataPastEventData(
            teamId,
            !!withLoader,
            {
              homeTeamId: homeTeam.teamId,
              awayTeamId: awayTeam.teamId,
            },
            true
          );
        }
        if (awayTeam && awayTeam.teamId && awayTeam.teamId !== "00") {
          setTimeout(
            () =>
              getDataPastEventData(
                teamId,
                !!withLoader,
                {
                  homeTeamId: homeTeam.teamId,
                  awayTeamId: awayTeam.teamId,
                },
                false
              ),
            2100
          );
        }
      } // if is a future nothing happen
    },
    [dataMeta.type, getDataLivePractice, getDataPastEventData, teamId]
  ); // teamId fot Games

  useEffect(() => {
    getData();
  }, [id, dataMeta.type, (isJustFinished(dataMeta) || shouldDisplayProgressBar)? null : hasUpdate /*if is post processing ignore has update*/]);

  useEffect(() => {
    const alerts: any = [];
    if (
      hitedAlerts &&
      hitedAlerts[gameId] &&
      hitedAlerts[gameId].length !== 0
    ) {
      setCurrentHitedAlert(hitedAlerts[gameId]);
      hitedAlerts[gameId].map((alert: any) => {
        alerts.push(
          <Alert
            key={alert.key}
            message={"Player Alert"}
            description={`${moment
              .tz(alert.time, moment.tz.guess())
              .format("hh:mm:ss")} - ${alert.name} has hit ${
              alert.metricValue
            } ${alert.metric}.`}
            type="warning"
          />
        );
      });
      setStoredAlerts(alerts);
    }
  }, [hitedAlerts]);

  useEffect(() => {
    loadCustomTable(user.email);
    loadCustomTable(user.email, true);
  }, []);
  useEffect(() => {
    if (data.meta.homeTeam.teamId && dataMeta.type === LIVE_PRACTICE) {
      loadCustomAlerts(user.email, data.meta.homeTeam.teamId);
      loadSpeedAlerts(user.email, data.meta.homeTeam.teamId);
    }
  }, [data.meta.homeTeam.teamId]);

  useEffect(() => {
    if (speedAlerts && speedAlerts.customSpeedAlerts) {
      const foundWithSome = speedAlerts.customSpeedAlerts.some(
        (obj: SpeedAlertsType) => obj.active === true
      );
      setLiveMonitor(foundWithSome);
    }
  }, [speedAlerts.customSpeedAlerts]);

  useEffect(() => {
    if (dataMeta?.gameId) loadPlayersNoteType(dataMeta.gameId);
  }, [dataMeta?.gameId]);
  useEffect(() => {
    if (dataMeta.type === PAST_PRACTICE && isJustFinished(dataMeta)) {
      getLiveData(
        !(data[dataScope].players.length > 0),
        teamId,
        listOfPlayersExcluded,
        isMobile
      );
    }
  }, [isJustFinished(dataMeta)]);

  useEffect(
    () => {
      if (dataMeta.type !== LIVE_PRACTICE && listOfPlayersExcluded !== null) {
        rendersCounter.current++;
        if (rendersCounter.current > 1) {
          if (callExcluded.current) {
            clearTimeout(callExcluded.current);
          }
          callExcluded.current = setTimeout(() => {
            excludePlayersAvg();
          }, 5000);
        }
      }
    },
    !hidden && dataMeta.type === LIVE_PRACTICE ? [] : [listOfPlayersExcluded]
  );
  useInterval(
    () => {
      getLiveData(
        !(data[dataScope].players.length > 0),
        teamId,
        listOfPlayersExcluded,
        isMobile,
        liveMonitor
      );
      setCurrentAlert(customAlerts.customAlerts);
    },
    !hidden && dataMeta.type === LIVE_PRACTICE
      ? LOAD_EVENTS_TIME_LIVE_PAGE
      : null
  );

  if (!data) {
    history.push("/games");
    return <Loader style={{ height: "100%" }} />;
  }
  const changeTab = (tab: string) => {
    const params = history.location.pathname.split("/").slice(0, 6);
    params.push(tab);
    params.push("page");
    return params.join("/");
  };

  const metrics =
    data[dataScope] && data[dataScope].highlights ? (
      <Metrics
        liveData={data[dataScope]}
        shownHighlights={shownHighlights}
        setShownHighlights={setShownHighlights}
        live={dataMeta.type === LIVE_PRACTICE}
        customLoad={customTable}
        customLoadLive={customTableLive}
      />
    ) : null;

  const body =
    eventType === PRACTICE && dataMeta.type === LIVE_PRACTICE ? (
      <>
        {metrics}
        <CondensedView
          shownHighlights={shownHighlights}
          hidden={hidden}
          playerNotes={playersNoteTypes}
          customAlerts={customAlerts.customAlerts}
          hitedAlerts={
            hitedAlerts && hitedAlerts[gameId]
              ? hitedAlerts[gameId]
              : currentHitedAlert
          }
          setOpenDrawer={setOpenDrawer}
          openDrawer={openDrawer}
          updateSpeeds={updateSpeeds}
          updateSelectedPlayers={updateSelectedPlayers}
          selectedPlayers={selectedPlayers}
          setShowUpdateSpeeds={setShowUpdateSpeeds}
          showUpdateSpeeds={showUpdateSpeeds}
          setSelectedPlayers={setSelectedPlayers}
          setUpdateSpeeds={setUpdateSpeeds}
        />
      </>
    ) : (
      <Tabs
        style={{ display: "none" }}
        activeKey={subTab}
        id="uncontrolled-tab-example"
        onSelect={(e: string | null) => {
          history.push({ pathname: changeTab(e || "") });
        }}
        mountOnEnter
        unmountOnExit
      >
        <Tab
          eventKey="condensed"
          title={
            <span>
              <CondensedLogo />
              Condensed View
            </span>
          }
        >
          {metrics}
          <CondensedView
            shownHighlights={shownHighlights}
            hidden={hidden}
            hasUpdate={hasUpdate}
            playerNotes={playersNoteTypes}
            targetedReprocess={targetedReprocess}
            updateTargetedPlayers={updateTargetedPlayers}
            targetedPlayers={targetedPlayers}
            customAlerts={customAlerts.customAlerts}
            hitedAlerts={
              hitedAlerts && hitedAlerts[gameId]
                ? hitedAlerts[gameId]
                : currentHitedAlert
            }
            setOpenDrawer={setOpenDrawer}
            openDrawer={openDrawer}
            updateSpeeds={updateSpeeds}
            updateSelectedPlayers={updateSelectedPlayers}
            selectedPlayers={selectedPlayers}
            setShowUpdateSpeeds={setShowUpdateSpeeds}
            showUpdateSpeeds={showUpdateSpeeds}
            setSelectedPlayers={setSelectedPlayers}
            setUpdateSpeeds={setUpdateSpeeds}
          />
        </Tab>
        <Tab
          eventKey="expanded"
          title={
            <span>
              <ExpandedLogo />
              Expanded View
            </span>
          }
        >
          {metrics}
          <ExpandedView
            shownHighlights={shownHighlights}
            hidden={hidden}
            hasUpdate={hasUpdate}
            playerNotes={playersNoteTypes}
            targetedReprocess={targetedReprocess}
            updateTargetedPlayers={updateTargetedPlayers}
            targetedPlayers={targetedPlayers}
          />
        </Tab>
        <Tab eventKey="metrics" title={`SOME TEXT GOES HERE`}>
          <MetricByPeriodView />
        </Tab>
      </Tabs>
    );
  const nextDay =
    eventType !== PRACTICE && data.meta.homeTeam.data.league !== LEAGUES.NFL
      ? new Date(dataMeta.startTime)
      : DateFns.addDays(new Date(dataMeta.startTime), 1);
  console.log(nextDay);
  const utcNextDay = new Date(
    Date.UTC(
      nextDay.getFullYear(),
      nextDay.getMonth(),
      nextDay.getDate(),
      13,
      0,
      0,
      0
    )
  );
  return (
    <>
      <div className="condensed-t">
        <FiltersTabPerformance
          dataInProgress={shouldDisplayProgressBar}
          loadData={() => {
            if (dataMeta.type === LIVE_PRACTICE) {
              // without entities call
              getLiveData(false, teamId, listOfPlayersExcluded, isMobile);
            } else {
              getData(true);
            }
          }}
          setOpenDrawer={setOpenDrawer!}
        />
        {dataMeta.type === FUTURE_PRACTICE ? (
          <Loader
            style={{ height: "calc(100vh - 108px)" }}
            forceMessage="Practice hasn't started. Start the practice to see live performance data."
          />
        ) : !isCC(user) &&
          dataMeta.type === PAST_GAME &&
          DateFns.isAfter(utcNextDay, new Date()) ? (
          <Loader
            style={{ height: "calc(100vh - 108px)" }}
            forceMessage={
              user.league === LEAGUES.NFL
                ? `Data available  on ${DateFns.format(
                    nextDay,
                    "MM/dd/yyyy"
                  )} at 9:00 am EST`
                : `Data available when post processing is complete`
            }
          />
        ) : (
          <Loader
            style={{
              height: "calc(100vh - 174px)",
              border: "2px solid rgba(219, 225, 229, 0.6)",
            }}
            forceScope={viewPracticeGamePageScope}
            forceMessage={
              hasScope && isLoading && isLoading.count
                ? ""
                : hasScope &&
                  (isJustFinished(dataMeta) || shouldDisplayProgressBar) &&
                  (dataMeta[viewPracticeGamePageScope] === PLAYERS_DATA.LIVE ||
                    data[dataScope].players.length === 0)
                ? "Data is being processed"
                : ""
            }
          >
            {body}
          </Loader>
        )}
      </div>

      <Drawer
        title={`Alerts`}
        placement="right"
        maskClosable
        onClose={() => {
          if (setOpenDrawer) setOpenDrawer(false);
        }}
        visible={openDrawer}
        className="drawer-entities"
        width="350px"
      >
        {storedAlerts.length ? (
          storedAlerts
        ) : (
          <Alert
            key={"no_alert"}
            message={"Player Alert"}
            description={`No alerts have been recorded for this session.`}
            type="error"
          />
        )}
      </Drawer>
    </>
  );
};
export default TabPerformance;
